import { useSyncExternalStore } from 'react';

import { getTheme, setTheme, subscribe } from './ThemeStore';

export function useTheme() {
  const theme = useSyncExternalStore(subscribe, getTheme);

  return { theme, setTheme };
}
